var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.explanation)?_c('p',{staticClass:"explanation"},[_vm._v(_vm._s(_vm.explanation))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }